import { createGlobalStyle } from 'styled-components';

export const theme = {
  fonts: {
    heading: 'Poppins, sans-serif',
    body: 'Nunito, sans-serif'
  },
  colors: {
    primary: '#ff4b5c',
    primaryDark: '#d93545',
    secondary: '#4c8dff',
    secondaryLight: '#d6e4ff',
    bg: '#fdfefe',
    surface: '#ffffff',
    text: '#202124',
    muted: '#6e6e6e',
    border: 'rgba(0,0,0,0.06)',
    surfaceAlpha: 'rgba(255,255,255,0.75)'
  },
  space: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem'
  },
  radius: {
    sm: '6px',
    md: '12px',
    lg: '20px'
  },
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.08)',
    md: '0 4px 12px rgba(0,0,0,0.12)'
  },
  gradients: {
    button: 'linear-gradient(45deg, #ff4b5c 0%, #ff4b5cd9 100%)',
    card: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)'
  }
};

export const GlobalStyle = createGlobalStyle`
  *,*::before,*::after{box-sizing:border-box;}
  html{scroll-behavior:smooth;}
  body{
    margin:0;
    min-height:100vh;
    background:${theme.colors.bg};
    color:${theme.colors.text};
    font-family:${theme.fonts.body};
    line-height:1.6;
    -webkit-font-smoothing: antialiased;
  }
  img,picture{max-width:100%;display:block;}
  a{text-decoration:none;color:inherit;}
`; 